<template>
  <div id="modalForm">
    <form
      ref="form"
      v-kendo-validator="validatorOptions()"
      @submit.prevent="submitDefault"
    >
      <b-modal
        v-model="show"
        :scrollable="scrollable"
        :no-close-on-backdrop="noCloseOnBackdrop"
        :size="size"
        class="spb-modal-class"
        @hide="close"
        v-bind:hide-footer="hideFooter"
      >
        <template v-slot:modal-title>
          <slot name="title"></slot>
        </template>
        <slot name="body"></slot>

        <template v-slot:modal-footer>
          <slot name="actions">
            <slot name="customButtons"></slot>
            <div v-if="!hideDefaultActions" class="row">
              <b-btn-group class="mr-2">
                <b-btn block variant="default" @click="close">{{
                  textClose
                }}</b-btn>
              </b-btn-group>
              <b-btn-group v-if="showSubmit" class="mr-2">
                <b-btn
                  block
                  variant="primary"
                  :disabled="disableSubmit"
                  type="submit"
                >{{ textSubmit }}</b-btn
                >
              </b-btn-group>
            </div>
          </slot>
        </template>
      </b-modal>
    </form>
  </div>
</template>
<script>
export default {
  props: {
    value: Boolean,
    model: { type: String, default: 'model' },
    size: { type: String, default: '' },
    textSubmit: { type: String, default: 'Salvar' },
    textClose: { type: String, default: 'Cancelar' },
    hideFooter: { type: Boolean, default: false },
    submit: Function,
    disableSubmit: { type: Boolean, default: false },
    showSubmit: { type: Boolean, default: true },
    noCloseOnBackdrop: { type: Boolean, default: true },
    scrollable: { type: Boolean, default: true },
    hideDefaultActions: { type: Boolean, default: false }
  },
  data() {
    return {
      defaultModel: null,
      cleared: true
    }
  },
  computed: {
    show: {
      get() {
        if (!this.value && this.$refs && this.$refs.form) {
          let th = this
          if (
            th.model &&
            th.$parent &&
            th.$parent[th.model] &&
            th.defaultModel
          ) {
            th.$nextTick(function () {
              if (!th.cleared) {
                var data = th.$api.UTIL.Functions.CopyObject(th.defaultModel)
                Object.keys(data).forEach(k => {
                  th.$parent[th.model][k] = data[k]
                })
                th.$parent[th.model] = Object.assign({}, data)
                th.$set(th.$parent, th.model, data)
                th.$refs.form.reset()
                th.cleared = true
              }
            })
          }
        } else if (this.value) {
          this.cleared = false
        }
        return this.value
      },
      set(value) {}
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.model && this.$parent && this.$parent[this.model]) {
        this.$nextTick(function () {
          let th = this
          var unWatch = th.$watch(
            '$store.getters.activeRequests',
            function (newValue, oldValue) {
              if (newValue === 0) {
                unWatch()
                this.$nextTick(function () {
                  this.defaultModel = this.$api.UTIL.Functions.CopyObject(
                    this.$parent[this.model]
                  )
                })
              }
            },
            { deep: true }
          )
        })
      }
    })
  },
  methods: {
    close: function () {
      this.$parent.show = false
      this.$parent.$emit('close')
    },
    submitDefault: function (e) {
      e.preventDefault()
      if (this.$api.UI.FormValidate(this)) {
        if (this.submit) {
          this.submit()
        }
      }
    },
    validatorOptions: function () {
      return {
        rules: {
          money: function (input) {
            var el = input[0]
            el.setCustomValidity('')
            if (el.getAttribute('required') && el.getAttribute('data-value')) {
              var value = kendo.parseFloat(el.value)
              if (value <= 0) {
                el.setCustomValidity('é obrigatório')
                return false
              }
            }
            return true
          }
        },
        errorTemplate: '' // '<span class="k-form-error k-invalid-msg" data-for="search" id="search-error"><span class="k-icon k-i-warning"> </span>&nbsp;#=message#</span>'
      }
    }
  },
}
</script>

<style>
#modalForm .k-invalid + .k-form-error.k-invalid-msg {
  display: block !important;
}
</style>
